var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfResultsFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66667 0.666992C2.48986 0.666992 2.32029 0.73723 2.19526 0.862254C2.07024 0.987279 2 1.15685 2 1.33366V14.667C2 14.8438 2.07024 15.0134 2.19526 15.1384C2.32029 15.2634 2.48986 15.3337 2.66667 15.3337C2.84348 15.3337 3.01305 15.2634 3.13807 15.1384C3.2631 15.0134 3.33333 14.8438 3.33333 14.667V10.0003H13.3333C13.459 10.0004 13.582 9.96493 13.6884 9.89807C13.7947 9.83121 13.88 9.73567 13.9345 9.62245C13.9889 9.50922 14.0102 9.38293 13.996 9.25812C13.9817 9.13331 13.9325 9.01506 13.854 8.91699L11.5207 6.00033L13.854 3.08366C13.9325 2.9856 13.9817 2.86735 13.996 2.74253C14.0102 2.61772 13.9889 2.49143 13.9345 2.3782C13.88 2.26498 13.7947 2.16944 13.6884 2.10258C13.582 2.03573 13.459 2.00028 13.3333 2.00033H3.33333V1.33366C3.33333 1.15685 3.2631 0.987279 3.13807 0.862254C3.01305 0.73723 2.84348 0.666992 2.66667 0.666992ZM11.946 3.33366L10.146 5.58366C10.0513 5.7019 9.99975 5.84886 9.99975 6.00033C9.99975 6.1518 10.0513 6.29875 10.146 6.41699L11.946 8.66699H3.33333V3.33366H11.946Z",
    fill: "url(#paint0_linear_0_10)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_10",
    x1: 2,
    y1: 8.00033,
    x2: 11.8668,
    y2: 8.03332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA44E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfResultsFlag);
export default __webpack_public_path__ + "static/media/cf-results-flag.028828af225aff23fe0e5c4f2a2c1472.svg";
export { ForwardRef as ReactComponent };